import React from 'react';
import type { DraggableAttributes, DraggableSyntheticListeners } from '@dnd-kit/core';
import { DragIndicator } from '@mui/icons-material';
import { IconButton } from '@mui/material';

interface DragHandleProps {
  listeners?: DraggableSyntheticListeners;
  attributes?: DraggableAttributes;
}

export const DragHandle: React.FC<DragHandleProps> = ({ listeners, attributes }) => {
  return (
    <IconButton
      {...listeners}
      {...attributes}
      sx={{
        borderRadius: 0,
        cursor: 'grab',
        '&:active': {
          cursor: 'grabbing',
        },
        color: 'text.secondary',
        '&:hover': {
          color: 'primary.main',
          bgcolor: 'action.hover',
        },
      }}
      aria-label="Drag to reorder"
    >
      <DragIndicator />
    </IconButton>
  );
};
